import { recipientsConstants } from "../actions/ask/recipients.js";

const defaultState = {
  status: {
    started: false,
    error: false,
    ended: false,
    errorInfo: {
      code: "",
      message: ""
    }
  },
  preSearchedCompany: null,
  recipients: [],
  page: 0
};

export default function recipient(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case recipientsConstants.CLEAR_SEARCHED_RECIPIENTS:
    return {
      ...defaultS,
      preSearchedCompany: null,
      recipients: defaultS.preSearchedCompany ? defaultS.preSearchedCompany : defaultS.recipients
    };
  case recipientsConstants.LOAD_SEARCHED_RECIPIENTS_SUCCESS:
    return {
      ...defaultS,
      status: {
        started: false,
        error: false,
        ended: true
      },
      preSearchedCompany: payload.companiesList,
      recipients: payload.data.items,
      hasMoreItems: payload.hasMoreItems,
      page: 0
    };
  case recipientsConstants.LOAD_RECIPIENTS_START:
    return {
      ...defaultS,
      status: {
        started: true,
        error: false,
        ended: false
      }
    };
  case recipientsConstants.LOAD_RECIPIENTS_SUCCESS:
    return {
      status: {
        started: false,
        error: false,
        ended: true
      },
      preSearchedCompany: payload.companiesList ? payload.companiesList : payload.result,
      recipients: payload.isAppend ? defaultS.recipients.concat(payload.result) : payload.result,
      hasMoreItems: payload.hasMoreItems,
      page: payload.page
    };
  case recipientsConstants.LOAD_RECIPIENTS_ERROR:
    return {
      ...defaultS,
      status: {
        started: false,
        error: true,
        ended: false,
        errorInfo: {
          code: payload && payload.code ? payload.code : 500,
          message: payload && payload.message ? payload.message : "Errore"
        }
      }
    };
  case recipientsConstants.LOAD_RECIPIENTS_RESET:
    return {
      ...defaultState
    };
  default:
    return defaultS;
  }
}
